<template>
  <div class="color-info text-center">
    <div v-if="possibleMultipart">
      The SMS may be sent in multiple parts if you have included dynamic
      variables.
    </div>

    <div v-if="multipart">The SMS may be sent in multiple parts.</div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-sms-length-warning></ak-sms-length-warning>
   */
  name: 'AkSmsLengthWarning',

  /**
   * @type {Boolean}
   * @description This prevents all element attributes that are not
   * defined in the props object from being applied to the rendered
   * component root element, the exception to this is "class" all
   * of the given classes would be merged with the component
   * defined ones.
   */
  inheritAttrs: false,

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    body: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const possibleMultipart = computed(() => {
      return props.body && props.body.length > 130 && props.body.length <= 160
    })

    const multipart = computed(() => {
      return props.body && props.body.length > 160
    })

    return {
      possibleMultipart,
      multipart,
    }
  },
})
</script>
